import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  padding: 0.1rem 0.1rem;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: #000000;
  backdrop-filter: blur(5px);
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.1);
  /* Ensure content never visually overflows the header bounds on small screens */
  overflow: visible;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }

  @media only screen and (max-width: 890px) {
    overflow: hidden;
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  /* Match the row's full height so the logo can size predictably */
  height: 100%;

  /* Prevent baseline whitespace and keep the logo within the header */
  img {
    display: block;
    max-height: 50px;
    height: auto;
    width: auto;
  }

  @media only screen and (max-width: 890px) {
    img {
      max-height: 48px;
    }
  }

  @media only screen and (max-width: 414px) {
    img {
      max-height: 44px;
    }
  }
`;

export const LogoTitle = styled.h1`
  margin: 0;
  font-size: 30px;
  color: #ffffff;
  font-family: 'SF Pro', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif;
  font-weight: 400;
  display: inline-block;
  vertical-align: middle;
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const Burger = styled("div")`
  @media only screen and (max-width: 890px) {
    display: block;
  }

  display: none;

  svg {
    /* Ensure burger icon looks pure white on mobile */
    fill: #ffffff;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  color: #ffffff;
  font-family: 'SF Pro', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #cccccc;
  transition: color 0.2s ease-in;
  margin: 0.5rem 2rem;
  font-family: 'SF Pro', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #cccccc;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-family: 'SF Pro', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif;
`;

export const Outline = styled(MenuOutlined)`
  font-size: 22px;
  color: #ffffff;
`;

export const Span = styled("span")`
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover,
  &:active,
  &:focus {
    color: rgb(255, 130, 92);
    text-underline-position: under;
    text-decoration: rgb(255, 130, 92) wavy underline;
  }
`;

export const DropdownContainer = styled("div")`
  position: relative;
  display: inline-block;
  margin-left: 6rem;

  &:hover > div {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;

export const DropdownTrigger = styled("div")`
  font-size: 1.4rem;
  color: #ffffff;
  padding: 8px 16px;
  cursor: pointer;
  font-weight: 400;
  font-family: 'SF Pro', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif;
  transition: color 0.2s ease-in;

  &:hover {
    color: #cccccc;
  }
`;

export const DropdownMenu = styled("div")`
  position: absolute;
  top: 100%;
  left: 16px;
  min-width: 180px;
  background-color: #1a1a1a;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.2s ease-in-out;
  z-index: 9999;
  padding: 8px 0;
  margin-top: 8px;

  &::before {
    content: '';
    position: absolute;
    top: -8px;
    left: -16px;
    right: 0;
    height: 8px;
  }
`;

export const DropdownItem = styled(Link)`
  display: block;
  padding: 12px 16px;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 400;
  font-family: 'SF Pro', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif;
  text-decoration: none;
  transition: background-color 0.2s ease-in;

  &:hover {
    background-color: #333333;
    color: #ffffff;
  }
`;
